import { CurrencyPipe } from '@angular/common';
import { Component, input } from '@angular/core';
import { KENDO_SKELETON } from '@progress/kendo-angular-indicators';
import { KENDO_CARD, KENDO_GRIDLAYOUT } from '@progress/kendo-angular-layout';
import { AgreementStatsDto } from '@unity/clients';
import { CardAgreementSummarySharedComponent } from '@unity/shared/card-agreement-summary-shared/card-agreement-summary-shared.component';

@Component({
  selector: 'unity-card-budget-summary-shared',
  standalone: true,
  imports: [KENDO_CARD, CurrencyPipe, KENDO_GRIDLAYOUT, KENDO_SKELETON, CardAgreementSummarySharedComponent],
  templateUrl: './card-budget-summary-shared.component.html',
  styleUrl: './card-budget-summary-shared.component.scss',
})
export class CardBudgetSummarySharedComponent {
  public readonly $agreement = input.required<AgreementStatsDto | undefined>({ alias: 'agreement' });
  public readonly $isLoading = input.required<boolean>({ alias: 'isLoading' });
}
